import { render, staticRenderFns } from "./company_invoices.vue?vue&type=template&id=5fbbd6ce"
import script from "./company_invoices.vue?vue&type=script&lang=js"
export * from "./company_invoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports